<template>
  <div>
    <span
      class="link"
      :class="{ 'primary--text': value.name === name }"
      v-for="{ name, title } in columns"
      :key="name"
      @click="onSort(name)"
    >
      <v-icon
        small
        v-if="value.name === name"
        :class="{ 'primary--text': value.name === name }"
      >
        {{
          `fas fa-long-arrow-alt-${value.direction === "asc" ? "up" : "down"}`
        }}
      </v-icon>
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: "BaseSort",
  props: {
    value: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSort(name) {
      const sort = {
        name,
        direction:
          name === this.value.name
            ? this.value.direction === "asc"
              ? "desc"
              : "asc"
            : this.value.direction
      };
      this.$emit("input", sort);
    }
  }
};
</script>

<style scoped>
.link {
  cursor: pointer;
}
.link + .link {
  margin-left: 0.5rem;
}
</style>
